import styled from 'styled-components'

import { theme } from 'src/styles'

export const Item = styled.details`
  margin-bottom: ${theme.space['spacing-sm']};

  > summary {
    list-style: none;

    &::marker,
    &::-webkit-details-marker {
      display: none;
    }
  }

  @media (${theme.media.desktop}) {
    margin-bottom: ${theme.space['spacing-md']};
  }
`

export const Header = styled.summary`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: transparent;
  border: none;
  outline: none;
  padding: ${theme.space['spacing-xs']} 0;
  width: 100%;
  margin: 0;
  cursor: pointer;

  &:focus-visible {
    position: relative;
    z-index: 1;
    box-shadow: 0 0 0 2px ${theme.colors['blue-border-default']};
  }

  .ds-accordion-arrow {
    transition: ${theme.transitions.default};
  }

  &.open .ds-accordion-arrow {
    transform: rotate(180deg);
  }
`

export const Title = styled.span`
  display: block;
  color: ${theme.colors['blue-text-default']};
  font-family: ${theme.fonts['font-family-base']};
  font-weight: ${theme.fontWeights['font-weight-medium']};
  font-size: ${theme.fontSizes['font-size-body-1']};
  line-height: ${theme.lineHeights['font-line-height-lg']};
  text-align: left;
  margin: 0;

  @media (${theme.media.desktop}) {
    font-size: ${theme.fontSizes['font-size-heading-5']};
  }
`

export const Subtitle = styled.span`
  display: block;
  margin-top: ${theme.space['spacing-xxs']};
  color: ${theme.colors['neutral-text-weak']};
  font-family: ${theme.fonts['font-family-base']};
  font-weight: ${theme.fontWeights['font-weight-regular']};
  font-size: ${theme.fontSizes['font-size-body-2']};
  line-height: ${theme.lineHeights['font-line-height-lg']};
  text-align: left;
`
